import React from 'react';

const CurrentBrandContext = React.createContext({
  currentBrand: null,
});

export default CurrentBrandContext;
